import axios from "axios";
import axiosInstance from "../axios_instance";
import cookieStorage from "../cookie_storage";

export async function createUser(body) {
  try {
    return await axiosInstance.post(`auth/register`, body);
  } catch (error) {
    return error;
  }
}

export async function googleLogin(body) {
  try {
    return await axiosInstance.post(`auth/google/login`, body);
  } catch (error) {
    return error;
  }
}

export async function getGoogleUser(access_token) {
  try {
    return await axios.get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${access_token}`);
  } catch (error) {
    return error;
  }
}

export async function updateUser(body, id) {
  try {
    return await axiosInstance.put(`user/${id}`, body);
  } catch (error) {
    return error;
  }
}

export async function subscribePush(body) {
  try {
    return await axiosInstance.post(`notifications/push/subscribe`, body);
  } catch (error) {
    return error;
  }
}

export async function unsubscribePush(body) {
  try {
    return await axiosInstance.post(`notifications/push/unsubscribe`, body);
  } catch (error) {
    return error;
  }
}

export async function deleteUser(id) {
  try {
    return await axiosInstance.delete(`user/${id}`);
  } catch (error) {
    return error;
  }
}

export async function getUsersorOrders(body) {
  try {
    return await axiosInstance.post(`user/get`, body);
  } catch (error) {
    return error;
  }
}

export async function getAllUsers(body) {
  try {
    return await axiosInstance.post(`user/get_users`, body);
  } catch (error) {
    return error;
  }
}

export async function getUserById(id, body) {
  try {
    return await axiosInstance.get(`user/${id}`, { params: body });
  } catch (error) {
    return error;
  }
}

export async function resetPassword(body) {
  try {
    return await axiosInstance.post(`user/reset_password`, body);
  } catch (error) {
    return error;
  }
}

export async function requestOTP(body) {
  try {
    const obj = { ...body, requestedAccess: 'Edit' };
    const res = await axiosInstance.post(`user/request_otp`, obj);
    return res;
  } catch (error) {
    return error;
  }
}

export async function verifyUserMobileOrEmail(body) {
  try {
    const obj = { ...body, requestedAccess: 'Edit' };
    const res = await axiosInstance.post(`user/verify_email_mobile`, obj);
    if (body?.isMobile) {
      cookieStorage.setItem("mobileVerified", 'true');
    }
    return res;
  } catch (error) {
    return error;
  }
}

export async function validateOTP(body) {
  try {
    const obj = { ...body, requestedAccess: 'Edit' };
    return await axiosInstance.post(`user/validate_otp`, obj);
  } catch (error) {
    return error;
  }
}

export async function changePassword(body) {
  try {
    const obj = { ...body, requestedAccess: 'Edit' };
    return await axiosInstance.post(`user/update_new_password`, obj);
  } catch (error) {
    return error;
  }
}
